import { Button } from '@avanta/shared/components/ui/Button';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';
import { Check, CheckSquare } from 'lucide-react';

export const Category = ({
  title,
  children,
}: React.PropsWithChildren<{ title: string }>): React.ReactElement => {
  const isSelectionMode = useConversationsStore(state => state.isSelectionMode);
  const toggleSelectionMode = useConversationsStore(state => state.toggleSelectionMode);

  return (
    <div className="border-b border-gray-200 mb-4">
      <div className="flex flex-row items-center gap-2 justify-between">
        <p className="text-sm font-medium">{title}</p>
        <Button variant="terciary" icon="only" onClick={toggleSelectionMode}>
          {isSelectionMode ? <Check /> : <CheckSquare />}
        </Button>
      </div>
      <div className="flex flex-col gap-2 py-2">{children}</div>
    </div>
  );
};
